import { render, staticRenderFns } from "./RecibosOld.vue?vue&type=template&id=4ed101e4"
import script from "./RecibosOld.vue?vue&type=script&lang=js"
export * from "./RecibosOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports